function DebugOutput(props) {
  return (
    <div>
      <br />
      <br />
      <h4>Errors:</h4>
      <pre>{JSON.stringify(props.errors, null, 2)}</pre>

      <h4>Values:</h4>
      <pre>{JSON.stringify(props.values, null, 2)}</pre>
    </div>
  );
}

export default DebugOutput;
